import React from 'react';
import { IconContainer } from './IconContainer';

const ListIcon = (props) => {
    return (
        <IconContainer aria-label="icon: list" {...props}>
            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M1.25 5.3125C1.25 6.17545 1.97754 6.875 2.875 6.875C3.77246 6.875 4.5 6.17545 4.5 5.3125C4.5 4.44956 3.77246 3.75 2.875 3.75C1.97754 3.75 1.25 4.44956 1.25 5.3125ZM17.5 4.53126V6.09376H6.12499V4.53126H17.5ZM17.5 10.7813V9.21875H6.12499V10.7813H17.5ZM17.5 15.4687V13.9062H6.12499V15.4687H17.5ZM1.25 14.6875C1.25 15.5504 1.97754 16.25 2.875 16.25C3.77246 16.25 4.5 15.5504 4.5 14.6875C4.5 13.8246 3.77246 13.125 2.875 13.125C1.97754 13.125 1.25 13.8246 1.25 14.6875ZM2.875 11.5625C1.97754 11.5625 1.25 10.8629 1.25 10C1.25 9.13705 1.97754 8.4375 2.875 8.4375C3.77246 8.4375 4.5 9.13705 4.5 10C4.5 10.8629 3.77246 11.5625 2.875 11.5625Z" fill="currentColor"/>
            </svg>
        </IconContainer>
    )
}

export { ListIcon };

